import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./shell.css";
import routes, { RouteProps } from "../../router/routers";

const Group = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <div className="menuGroup">
        <div className="menuGroupTitle">{title}</div>
        <div className="menuGroupItems">{children}</div>
    </div>
);

function isPathActive(pathname: string, to: string) {
    if (to === "/") return pathname === "/";
    return pathname === to || pathname.startsWith(to + "/");
}

type MenuLeaf = {
    path: string;
    name: string;
    icon?: any;
};

type MenuGroupT = { name: string; items: MenuLeaf[] };

function buildMenuFromRoutes(rs: RouteProps[]): MenuGroupT[] {
    return (rs || [])
        .filter((g) => g.showInMenu)
        .map((g) => ({
            name: g.name,
            items: (g.children || [])
                .filter((c) => c.showInMenu && !!c.path)
                .map((c) => ({
                    path: c.path as string,
                    name: c.name,
                    icon: c.icon
                }))
        }))
        .filter((g) => g.items.length > 0);
}

const MenuItem = ({
    to,
    label,
    active,
    icon
}: {
    to: string;
    label: string;
    active: boolean;
    icon?: any;
}) => {
    const IconComp = icon as any;

    return (
        <NavLink to={to} className={"menuItem" + (active ? " menuItemActive" : "")}>
            {/* icon */}
            {IconComp ? (
                <span className="menuItemIcon">
                    <IconComp size={16} />
                </span>
            ) : (
                <span className="menuItemIcon menuItemIconPlaceholder" />
            )}

            {/* label */}
            <span className="menuItemLabel" title={label}>
                {label}
            </span>
        </NavLink>
    );
};

export default function SideMenu() {
    const { pathname } = useLocation();
    const menuGroups = React.useMemo(() => buildMenuFromRoutes(routes), []);

    return (
        <div className="sideMenu sideMenuTeal">
            <div className="sideMenuScroll">
                {menuGroups.map((g) => (
                    <Group key={g.name} title={g.name}>
                        {g.items.map((it) => (
                            <MenuItem
                                key={it.path}
                                to={it.path}
                                label={it.name}
                                icon={it.icon}
                                active={isPathActive(pathname, it.path)}
                            />
                        ))}
                    </Group>
                ))}
            </div>
        </div>
    );
}